// VSB pair offer: after the first add to cart on the page, offer one more
// product. See sections/vsb-pair-offer.liquid.
if (!customElements.get('vsb-pair-offer')) {
  customElements.define(
    'vsb-pair-offer',
    class VsbPairOffer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.addButton = this.querySelector('[data-add]');
        this.error = this.querySelector('.vsb-offer__error');
        try {
          this.properties = JSON.parse(this.querySelector('[data-properties]').textContent);
        } catch (e) {
          this.properties = {};
        }

        this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        // A click on the backdrop lands on the dialog itself.
        this.dialog.addEventListener('click', (e) => e.target === this.dialog && this.close());
        this.addButton.addEventListener('click', () => this.addPair());

        // Dawn's product forms announce a successful add (pubsub.js; PUB_SUB_EVENTS
        // is a top-level const in constants.js, so it is not on window).
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source !== 'product-form' || String(event.productVariantId) === this.dataset.variant) return;
            if (!this.shouldShow()) return;
            // Dawn opens its own notification straight after this event; close it.
            setTimeout(() => {
              this.closeThemeCart();
              this.open();
            });
          });
        }

        // Links that add to the cart (/cart/add?id=…): add in the background, then offer.
        this.onLinkClick = this.onLinkClick.bind(this);
        document.addEventListener('click', this.onLinkClick);

        // Theme editor: selecting the section shows the offer.
        document.addEventListener('shopify:section:select', (e) => e.detail.sectionId === this.dataset.section && this.open());
        document.addEventListener('shopify:section:deselect', (e) => e.detail.sectionId === this.dataset.section && this.close());
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        document.removeEventListener('click', this.onLinkClick);
      }

      get cartAddUrl() {
        return (window.routes && window.routes.cart_add_url) || '/cart/add';
      }

      get cartUrl() {
        return (window.routes && window.routes.cart_url) || '/cart';
      }

      shouldShow() {
        if (this.dataset.once !== 'true') return true;
        try {
          return !sessionStorage.getItem(this.dataset.key);
        } catch (e) {
          return !this.shown;
        }
      }

      markShown() {
        this.shown = true;
        try {
          sessionStorage.setItem(this.dataset.key, '1');
        } catch (e) {
          /* private mode: once per page instead */
        }
      }

      open() {
        if (this.dialog.open) return;
        this.markShown();
        this.error.hidden = true;
        this.dialog.showModal();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      closeThemeCart() {
        const cart = document.querySelector('cart-notification, cart-drawer');
        if (cart && typeof cart.close === 'function') cart.close();
      }

      onLinkClick(event) {
        const link = event.target.closest && event.target.closest('a[href*="/cart/add"]');
        if (!link || !this.shouldShow() || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey) return;
        const url = new URL(link.href, location.origin);
        const id = Number(url.searchParams.get('id'));
        if (!id) return;
        event.preventDefault();
        const properties = {};
        url.searchParams.forEach((value, key) => {
          const m = key.match(/^properties\[(.+)\]$/);
          if (m) properties[m[1]] = value;
        });
        this.add({ id, quantity: Number(url.searchParams.get('quantity')) || 1, properties })
          .then(() => this.open())
          .catch(() => (location.href = link.href));
      }

      add(item) {
        return fetch(`${this.cartAddUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] }),
        }).then((response) => {
          if (!response.ok) throw new Error(`cart/add ${response.status}`);
          return response.json();
        });
      }

      addPair() {
        const label = this.addButton.innerHTML;
        this.addButton.disabled = true;
        this.addButton.setAttribute('aria-busy', 'true');
        this.error.hidden = true;
        this.add({ id: Number(this.dataset.variant), quantity: 1, properties: this.properties })
          .then(() => {
            location.href = this.cartUrl;
          })
          .catch(() => {
            this.addButton.disabled = false;
            this.addButton.removeAttribute('aria-busy');
            this.addButton.innerHTML = label;
            this.error.hidden = false;
          });
      }
    }
  );
}
